import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "8c470d23-fba2-4f34-b9ba-7e2f274229e4",
    authority:
      "https://login.microsoftonline.com/c2ec9b46-87e2-48a2-a6e1-ace96c0441e5",
    redirectUri: "/",
    postLogoutRedirectUri: "/",
    clientCapabilities: ["CP1"],
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

export const protectedResources = {
  apiScopes: {
    scopes: {
      read: ["api://7cee488c-92df-4ca8-8f52-52b8ecce6ffa/InsidePortal.Read"],
      write: [
        "api://7cee488c-92df-4ca8-8f52-52b8ecce6ffa/InsidePortal.ReadWrite",
      ],
    },
  },
};

export const loginRequest = {
  scopes: [
    ...protectedResources.apiScopes.scopes.read,
    ...protectedResources.apiScopes.scopes.write,
  ],
  prompt: "select_account"
};